/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1GoverningcodesQueryResponse } from '../../types/GetV1Governingcodes.ts'

export const getV1GoverningcodesQueryKey = () => [{ url: '/v1/GoverningCodes' }] as const

export type GetV1GoverningcodesQueryKey = ReturnType<typeof getV1GoverningcodesQueryKey>

/**
 * {@link /v1/GoverningCodes}
 */
export async function getV1Governingcodes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1GoverningcodesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/GoverningCodes`, ...requestConfig })
    return res
}

export function getV1GoverningcodesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1GoverningcodesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1GoverningcodesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1GoverningcodesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Governingcodes(config)
        },
    })
}

/**
 * {@link /v1/GoverningCodes}
 */
export function useGetV1Governingcodes<
    TData = ResponseConfig<GetV1GoverningcodesQueryResponse>,
    TQueryData = ResponseConfig<GetV1GoverningcodesQueryResponse>,
    TQueryKey extends QueryKey = GetV1GoverningcodesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1GoverningcodesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1GoverningcodesQueryKey()

    const query = useQuery(
        {
            ...getV1GoverningcodesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
